
import React from 'react'
import NKSpinner from '@norkart/ikoner/dist/NKSpinner'
import Modal from './modal'


let contentStyle = {
  textAlign: 'center',
  fontSize: '32px'
}

const LoadingScreen = ({tekst}) =>
  <Modal>
    <div style={contentStyle}>
      <NKSpinner size="3" />
      <div><span>{tekst}</span></div>
    </div>
  </Modal>

  export default LoadingScreen


// WEBPACK FOOTER //
// ./src/felles/loading.jsx